import { formatDistanceToNow } from "date-fns";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
let TZ = "Europe/London";
export const setTimeZone = (tz) => { TZ = tz || "Europe/London"; };
export const currentTimeZone = () => TZ;

function parts(iso) {
  const d = new Date(iso);
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(d).map((x) => [x.type, x.value]));
  return { ...p, mon: MONTHS[Number(p.month) - 1] };
}

export const formatDateTime = (iso) => {
  if (!iso) return "Never";
  const p = parts(iso);
  return `${Number(p.day)} ${p.mon} ${p.year}, ${p.hour}:${p.minute}`;
};
export const formatDate = (iso) => {
  if (!iso) return "";
  const p = parts(iso);
  return `${Number(p.day)} ${p.mon} ${p.year}`;
};
export const formatTime = (iso) => {
  if (!iso) return "";
  const p = parts(iso);
  return `${p.hour}:${p.minute}`;
};
export const timeAgo = (iso) => (iso ? `${formatDistanceToNow(new Date(iso))} ago` : "Never");

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");

export const firstName = (name = "") => name.split(/\s+/)[0] || "";

export function greeting() {
  const h = Number(new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hour: "2-digit", hourCycle: "h23" }).format(new Date()));
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}
